if (!Array.prototype.last) {
    Array.prototype.last = function () {
        return this[this.length - 1];
    };
};

if (!Array.prototype.prepend) {
    Array.prototype.prepend = function (value) {
        var newArray = this.slice();
        newArray.unshift(value);
        return newArray;
    };
}

function loadChart(el, chartType, data) {
    let factory = new ChartFactory();
    let chart = factory.createChart(el, chartType, data);
    let $wrapper = $(el)
    $wrapper.find(".loading").remove();
    chart.draw();
}

function ChartFactory() {
    this.createChart = function (container, type, data) {
        let chart;
        if (type === "geoChart") {
            chart = new GeoChart(container, data);
        } else if (type === "barChart") {
            chart = new BarChart(container, data);
        } else if (type === "stackedBarChart") {
            chart = new StackedBarChart(container, data);
        } else if (type === "scatterChart") {
            chart = new ScatterChart(container, data);
        }
        return chart;
    }
}

function getChartOptions(el) {
    return {
        chartType: el.data("type")
    }
}

const distribution = (array, rangeLength = 1) => {
    if (!Array.isArray(array))
        throw new Error(
            `expected first argument to be any Array<Number> but got item ${array} of type ${typeof array}`
        );
    return array.sort((a, b) => a - b).reduce((prev, current) => {
        const a = Math.round(current / rangeLength);
        const r = rangeLength === 1 ? a : `${(a - 1) * rangeLength + 1},${a * rangeLength}`;
        const lastVal = prev[r] || 0;
        const newVal = { ...prev };
        newVal[r] = lastVal + 1;
        return newVal;
    }, {});
};

$(function(){
    $.fn.selectpicker.defaults.countSelectedText = function (numSelected, numTotal) {
        if (numSelected == numTotal){
            return "Selezione completa"
        } else {
            return '{0} di {1} macroregioni';
        }
        
    }
})

$(function () {

    const medie = $("#data-source").data("medie");
    const livelli = $("#data-source").data("livelli");
    const data = {medie: medie, livelli: livelli };
    //console.log(data);

    $(".chart-container").each(function () {
        let $this = $(this);
        let $wrapper = $this
        let options = getChartOptions($this);
        $wrapper.append('<div class="loading">' +
            '<div class="subloading">' +
            '    <div class="progress-spinner progress-spinner-double progress-spinner-active">' +
            '        <div class="progress-spinner-inner"></div>' +
            '        <div class="progress-spinner-inner"></div>' +
            '        <span class="sr-only">Caricamento...</span>' +
            '    </div>' +
            '</div>' +
            '</div>');
        loadChart($this.get(0), options.chartType, data);
    })
})

$(function(){
    $('.selectpicker').selectpicker()
})

$(function(){
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        $(".chart-container").not(".map-container").each(function () {
            var instance = echarts.getInstanceByDom(this);
            instance.resize();
        });
    });
})


$(function () {
    $('.download-chart').on('click', function (ev) {
        ev.preventDefault();
        var chartContainer = $(this).closest(".row").find(".chart-container");
        var instance = echarts.getInstanceByDom(chartContainer[0]);
        var url = instance.getConnectedDataURL({
            type: "png",
            backgroundColor: '#fff'
        });
        var $a = document.createElement('a');
        $a.download = instance.getModel().option.title[0].text + '.png';
        $a.target = '_blank';
        $a.href = url;
        var evt = new MouseEvent('click', {
            view: document.defaultView,
            bubbles: true,
            cancelable: false
        });
        $a.dispatchEvent(evt);
    });
    
})
class Chart {
    constructor(container, data, options = {}) {
        this.container = container;
        this.rawData = data;

        this.mode = options.mode ? options.mode : Object.keys(data)[0];
        this.anno = options.anno ? options.anno : data[this.mode][1].anno;
        var currYear = this.anno;
        
        this.domain = options.domain ? options.domain : data[this.mode].find(function (el) { return el.anno === currYear }).types[0].domain;
        this.livello = options.livello ? options.livello : null;
        this.unselectedAreas = options.unselectedAreas ? options.unselectedAreas : []; // ["isole", "sud", "italia"];
        this.indicatore = options.indicatore ? options.indicatore : {}; // { name: "genere", value: "uomini" }; 

        var currYear = this.anno;
        var currDomain = this.domain;
        

        this.filtersContainer = $(this.container).closest(".row").find(".chart-filters");
        this.baseFilterObject = this.rawData[this.mode];
        
        var domainsPerYear = this.baseFilterObject.find(function (el) { return el.anno === currYear }).types;

        this.yearFilterValues = this.baseFilterObject.map((el, index) => ({ name: el.anno, label: `${el.anno} - Ciclo ${this.romanize(index + 1)}` }));
        this.domainFilterValues = domainsPerYear.map(el => el.domain);
        this.selectedComparison = options?.selectedComparison || [this.domainFilterValues[0], this.domainFilterValues[1]];
        this.indicatorFilterValues = domainsPerYear.find(function (el) { return el.domain == currDomain }).values.slice(1).map(i => {
            const { values, ...cloned } = i;
            return cloned;
        })
        this.filteredObj = [];
        this.chartColorsBlu = ["#145e9a", "#0072bc", "#5088c7", "#799ed3", "#9cb5de", "#becde9"].reverse();
        this.chartColorsGreen = ["#b9eec5", "#79df91", "#4ad469", "#10bf38", "#38974e", "#417a4e"];
        this.chartColorsRed = ["#ce0067", "#db4b7e", "#e67497", "#f098b0", "#f7bac9", "#fcdde4"].reverse();
        this.chartData = this._getChartData(data);

        this.options = Object.assign({}, options, {
            animation: true,
            animationEasing: 'elasticOut',
        });


        this.areasMapping = [
            { name: "nord-ovest", label: "Nord Ovest", id: "IT-C" },
            { name: "nord-est", label: "Nord Est", id: "IT-H" },
            { name: "centro", label: "Centro", id: "IT-I" },
            { name: "sud", label: "Sud", id: "IT-F" },
            { name: "isole", label: "Isole", id: "IT-G" },
            { name: "italia", label: "Italia", id: "IT" }
        ]

        this.levelMapping = [
            { name: 1, label: "Low performer", colorBlu: "#becde9", colorGreen: "#b9eec5", colorRed: "#fcdde4" },
            { name: 2, label: "Livello 2", colorBlu: "#9cb5de", colorGreen: "#79df91", colorRed: "#f7bac9" },
            { name: 3, label: "Livello 3", colorBlu: "#799ed3", colorGreen: "#4ad469", colorRed: "#f098b0" },
            { name: 4, label: "High performer", colorBlu: "#5088c7", colorGreen: "#10bf38", colorRed: "#e67497" }
        ]

    }

    _getChartData() {
        const chartData = JSON.parse(JSON.stringify(this.rawData[this.mode])); // clono la struttura dati di this.rawData
        const yearObj = chartData.find(el => el.anno === this.anno);
        const domainObj = yearObj.types.find(el => el.domain === this.domain);
        let filteredObj = null;

        // Filtro per indicatore (genere, età etc...)
        if (!!Object.keys(this.indicatore).length) {
            filteredObj = domainObj.values.find(el => el.name === this.indicatore.name).values;
            this.filteredObj = JSON.parse(JSON.stringify(filteredObj));
            if (this.indicatore.value) {
                for (var i = 0; i < filteredObj.length; i++) {
                    if (this.mode == "livelli") {
                        for (let n = 0; n < filteredObj[i].values.length; n++) {
                            filteredObj[i].values[n].values = filteredObj[i].values[n].values.find(el => el.name === this.indicatore.value)
                        }
                    } else {
                        filteredObj[i].values = filteredObj[i].values.find(el => el.name === this.indicatore.value)
                    }
                }
            }
        } else {
            filteredObj = domainObj.values[0].values;
            this.filteredObj = JSON.parse(JSON.stringify(filteredObj));
        }

        //console.log("filteredObj con indicatore: ", this.filteredObj);

        // Filtro per macroregioni non selezionate
        if (this.unselectedAreas.length) {
            filteredObj = filteredObj.filter(el => this.unselectedAreas.indexOf(el.area) !== -1)
        }

        // Filtro per livello (solo per il mode = livelli)
        if (this.mode == "livelli" && this.livello) {
            for (var i = 0; i < filteredObj.length; i++) {
                //console.log(filteredObj[i].values);
                filteredObj[i].values = filteredObj[i].values.find(el => el.level === parseInt(this.livello))
                this.filteredObj[i].values = this.filteredObj[i].values.find(el => el.level === parseInt(this.livello))
                //console.log(filteredObj[i].values);
            }
            //this.filteredObj = JSON.parse(JSON.stringify(filteredObj));
            // console.log("filteredObj dopo: ", this.filteredObj);
        }
        //console.log(filteredObj);
        return filteredObj;
    }

    _getValueObject(obj) {
        for (let i = 0; i < Object.keys(obj).length; i++) {
            var key = Object.keys(obj)[i];
            if (key === "value") {
                return obj;
            } else {
                if (typeof obj[key] === 'object') {
                    return this._getValueObject(obj[key])
                }
            }
        }
    }

    _getAllValues(obj, keyToFind) {
        return Object.entries(obj)
            .reduce((acc, [key, value]) => (key === keyToFind)
                ? (value !== "nd" ? acc.concat(value) : acc)
                : (typeof value === 'object')
                    ? acc.concat(this._getAllValues(value, keyToFind))
                    : acc
                , [])
    }

    _getColor(area) {
        switch (area) {
            case 'nord-ovest':
                return '#25b6e5'
            case 'nord-est':
                return '#ef2e33'
            case 'centro':
                return '#ffd54e'
            case 'sud':
                return '#95ca72'
            case 'isole':
                return '#fd65b2'
            case 'italia':
                return 'blueviolet'
            default:
                return 'black'
        }
    }

    _loading() {
        $(this.container).append('<div class="loading">' +
            '<div class="subloading">' +
            '    <div class="progress-spinner progress-spinner-double progress-spinner-active">' +
            '        <div class="progress-spinner-inner"></div>' +
            '        <div class="progress-spinner-inner"></div>' +
            '        <span class="sr-only">Caricamento...</span>' +
            '    </div>' +
            '</div>' +
            '</div>');
    }

    drawFilters(data) {
        return "";
    }

    drawFilter(conf, options, domElement = null, reDraw = false) {
        //console.log(conf);
        if (reDraw) {
            $("select[name='" + conf.name + "']", this.filtersContainer).closest(".chart-filter-container").remove();
        }
        const isMultiple = conf.multiple || false;
        const isSelected = conf.selected || false;
        const warningInput = ['livello', 'indicatoreValue'];
        const template = `
            <div class="chart-filter-container">
                <label class="${warningInput.includes(conf.name) ? 'text-danger' : ''}">${conf.label}</label>
                <select 
                    data-style-base="btn ${warningInput.includes(conf.name) ? 'border-danger' : ''}" 
                    name="${conf.name}" ${isMultiple ? 'multiple data-selected-text-format="count > 2"' : ''} 
                    class="selectpicker chart-filter-input">
                    ${this._getOptions(options, conf.selectedOpts)}
                </select>
            </div>`;

        if (domElement) {
            domElement.after(template);
        } else {
            this.filtersContainer.append(template);
        }

        if (reDraw) {
            $("select[name='" + conf.name + "']", this.filtersContainer).val(this[conf.name]).selectpicker();
        }

        this._setFilterEvent(conf.name);
    }

    _setFilterEvent(inputName, callback) {
        const self = this;
        $("select[name='" + inputName + "']", this.filtersContainer).on("change", function () {
            let indicatoreKey = "";
            switch (inputName) {
                case "indicatore":
                    indicatoreKey = $(this).val();
                    $("select[name='indicatoreValue']", self.filtersContainer).closest(".chart-filter-container").remove();
                    if (!indicatoreKey) {
                        self.indicatore = {};
                    } else {
                        self.indicatore = { name: indicatoreKey, value: null };
                        self.drawFilter({ name: "indicatoreValue", label: "Valore dell'indicatore" },
                            self.indicatorFilterValues.find(o => o.name === indicatoreKey).options
                                .map(o => { return { name: (o.name || o), label: (o.label || o) } })
                                .prepend({ name: "", label: "Scegli un valore" })
                        );
                        $("select[name='indicatoreValue']", self.filtersContainer).selectpicker();
                    }

                    break;
                case "indicatoreValue":
                    indicatoreKey = $("select[name='indicatore']", self.filtersContainer).val();
                    self.indicatore = { name: indicatoreKey, value: $(this).val() };
                    var filterContainer = $(this).closest(".chart-filter-container");
                    if ($(this).val()) {
                        filterContainer.find("[class*='-danger']").removeClass("text-danger").removeClass("border-danger")
                    } else {
                        filterContainer.find("label").addClass("text-danger")
                        filterContainer.find("button.dropdown-toggle").addClass("border-danger")
                    }
                    break;
                case "mode":
                    self[inputName] = this.value;
                    const domElement = $("select[name='mode']", self.filtersContainer).closest(".chart-filter-container")
                    if ($(this).val() == "livelli") {
                        self.drawFilter({ name: "livello", label: "Scegli il livello" }, self.levelMapping.prepend({ name: "", label: "Scegli un livello" }), domElement);
                        $("select[name='livello']", self.filtersContainer).selectpicker();
                        $("select[name='indicatore'], select[name='indicatoreValue']", self.filtersContainer).closest(".chart-filter-container").remove();
                        self.indicatore = {};
                    } else { 
                        $("select[name='livello']", self.filtersContainer).closest(".chart-filter-container").remove();
                        self.drawFilter({ name: "indicatore", label: "Caratteristiche" }, self.indicatorFilterValues.prepend({ name: "", label: "Totale" }), domElement);
                        $("select[name='indicatore']", self.filtersContainer).selectpicker();
                    }
                    break;
                case "unselectedAreas":
                    self[inputName] = $(this).val();
                    break;
                case "selectedComparison":
                    self[inputName] = this.value.split(",");
                    console.log("selectedComparison", self[inputName])
                    break;
                case "livello":
                    self[inputName] = this.value;
                    var filterContainer = $(this).closest(".chart-filter-container");
                    if ($(this).val()) {
                        filterContainer.find("[class*='-danger']").removeClass("text-danger").removeClass("border-danger")
                    } else {
                        filterContainer.find("label").addClass("text-danger")
                        filterContainer.find("button.dropdown-toggle").addClass("border-danger")
                    }
                    break;
                case "anno":
                    self[inputName] = this.value;
                    console.log(inputName, this.value);
                    $("select[name='livello']", self.filtersContainer).closest(".chart-filter-container").remove();
                    $("select[name='indicatoreValue']", self.filtersContainer).closest(".chart-filter-container").remove();
                    break;
                default:
                    self[inputName] = this.value;
            }

            //console.log(self.anno, self.domain, self.mode, self.indicatore, self.livello, self.unselectedAreas);
            //console.log(self.options)
            if ((self.indicatore.name && !self.indicatore.value) || ((self.options.mode !== "livelli" && self.mode == 'livelli') && !self.livello)) {
                $(self.container).addClass("chart-container-disabled");
                return;
            } else {
                $(self.container).removeClass("chart-container-disabled");
            }

            if (callback) callback.call();
        })

    }

    //_getOptions(options, isSelected) {
    _getOptions(options, selectedOpts) {
        return options.map(o => {
            return (typeof (o) == "object" ? `<option ${selectedOpts?.includes(o.name) ? 'selected' : ''} value="${o.name}">${o.label}</option>` :
                `<option ${selectedOpts?.includes(o.name) ? 'selected' : ''} value="${o}">${o}</option>`);
        }).join("\n")
    }

    getTitle() {
        var out = `${this.anno} ${this.domain.toUpperCase()}`;
        if (this.mode == "livelli" && this.livello) {
            out += ` ${this.levelMapping.find(lev => lev.name == this.livello).label}`;
        }
        if (!this.indicatore.name && !this.indicatore.value) return out;
        var indicatoreObj = this.indicatorFilterValues.find(o => o.name === this.indicatore.name);
        out += ` ${indicatoreObj.label}: ${indicatoreObj.options.find(o => o.name === this.indicatore.value).label.toLowerCase()}`;
        return out;
    }

    capitalizeFirstLetter(val){
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }


    getTitleWidth() {
        if (window.innerWidth > 1599) {
            return 750
        } else if (window.innerWidth > 1199) {
            return 600
        } else if (window.innerWidth > 767) {
            return 550
        } else {
            return 400
        }
    }

    romanize(num) {
        if (isNaN(num))
            return NaN;
        var digits = String(+num).split(""),
            key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
                "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
                "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
            roman = "",
            i = 3;
        while (i--)
            roman = (key[+digits.pop() + (i * 10)] || "") + roman;
        return Array(+digits.join("") + 1).join("M") + roman;
    }

    draw() {
        throw "Not implemented on superclass";
    }
}
class GeoChart extends Chart {

    constructor(container, data, options) {
        super(container, data, options);
        this.color = $(this.container).data("color") || "#0072BC";
        this.geoChart = null;
        this.dataTable = null;
        this.dataView = null;
        this.chartOptions = {};
        this.needFilters = options?.needFilters === false ? false : true;
        this.chartData = this._getMyChartData();
        this.levelFilterValues = this.mode != "livelli" ? null : this.baseFilterObject[0].types[0].values[0].values[0].values.map(v => v.level);

        $(this.container).css({ height: ($(this.container).width() * 0.86) });

        if (this.needFilters) this.drawFilters();

        setTimeout(() => {
            google.charts.load("45", {
                packages: ["geochart"],
                mapsApiKey: 'AIzaSyA7Rlhio69lR70gjTBjtVgJRMSs9Kl31YU',
                language: "it"
            });
            google.charts.setOnLoadCallback(this.init.bind(this));

        }, 0);

    }

    init() {
        var values = this._getAllValues(this.filteredObj, "value") 
        //console.log(this.filteredObj);

        var colorvalues = [
            Math.floor(Math.min.apply(Math, values)),
            Math.ceil(Math.max.apply(Math, values))
        ]

        if (this.domain == "literacy"){
            var colorhex = ["#e3f4ff", this.color];
        } else if (this.domain == "numeracy"){
            var colorhex = ["#e8faec", "#38974e"];
        } else {
            var colorhex = ["#fae5ef", "#ce0067"];
        }
        

        this.dataTable = this._getDataTable();
        this.dataView = this._getDataView();
        this.chartOptions = this._getChartOptions(colorvalues, colorhex);

        google.visualization.GeoChart.setMapsSource("/assets/js/map");

        this.geoChart = new google.visualization.GeoChart(this.container);
        this.geoChart.draw(this.dataView, this.chartOptions);

        var self = this;
        google.visualization.events.addListener(this.geoChart, 'ready', function () {
            $(".download-geochart").removeClass("disabled")
            .off("click").on("click", function(ev){
                ev.preventDefault();
                var url = self.geoChart.getImageURI();
                var $a = document.createElement('a');
                $a.download = self.getTitle() + '.png';
                $a.target = '_blank';
                $a.href = url;
                var evt = new MouseEvent('click', {
                    view: document.defaultView,
                    bubbles: true,
                    cancelable: false
                });
                $a.dispatchEvent(evt);
            })

            // var downloadChartTrigger = $(self.container).closest(".row").find(".chart-title");
            // downloadChartTrigger.html(self.getTitle())
        });

    }

    drawFilters() {
        this.drawFilter({ name: "anno", label: "Anno", selectedOpts: [this.anno] }, this.yearFilterValues, null, this.options.needFilters);
        this.drawFilter({ name: "domain", label: "Dominio cognitivo" }, this.domainFilterValues, null, this.options.needFilters);
        this.drawFilter({ name: "mode", label: "Tipo di dato" }, [{ name: "medie", label: "Punteggio medio" }, { name: "livelli", label: "Percentuale di adulti per livello " }], null, this.options.needFilters);
        if (this.mode == "livelli") {
            this.drawFilter({ name: "livello", label: "Livello" }, this.levelFilterValues.map(l => {
                return this.levelMapping.find(el => el.name === l)
            }), null, this.options.needFilters);
        }
        this.drawFilter({ name: "indicatore", label: "Caratteristiche" }, this.indicatorFilterValues.prepend({ name: "", label: "Totale" }), null, this.options.needFilters);
    }

    _setFilterEvent(inputName) {
        const self = this;
        super._setFilterEvent(inputName, function () {
            //console.log("RIDISEGNO IL CHART!!!!");
            const chart = new GeoChart(self.container, self.rawData, {
                needFilters: (inputName == "anno"),
                anno: self.anno,
                mode: (inputName == "anno" ? null : self.mode),
                domain: (inputName == "anno" ? null : self.domain),
                indicatore: (inputName == "anno" ? null : self.indicatore),
                livello: (inputName == "anno" ? null : self.livello )
            });
        });

    }

    _getMyChartData() {
        //console.log(this.chartData);
        const chartData = this.chartData.filter(function (obj) {
            return obj.area !== "italia";
        });
        const italyData = this.chartData.find(function (obj) {
            return obj.area === "italia";
        });

        const out = [];
        for (let i = 0; i < chartData.length; i++) {
            const valueObject = this._getValueObject(chartData[i]);
            //if (valueObject.value == "nd") continue;
            out.push([
                {
                    "c": "Macroregione",
                    "f": this.areasMapping.find(el => el.name == chartData[i].area).label,
                    "v": this.areasMapping.find(el => el.name == chartData[i].area).id
                },
                {
                    "c": (this.mode != "livelli" ? "Punteggio medio" : `${valueObject.label ? valueObject.label : this.levelMapping.find(el => el.name === valueObject.level).label}`),
                    "v": (valueObject.value == "nd" ? null : valueObject.value)
                },
                {
                    "c": "Italia",
                    "v": this._getValueObject(italyData).value
                },
                {
                    "v": ""
                }
            ])
        }
        //console.log(out);
        return out;
    }

    _getDataTable() {
        var dataTable = new google.visualization.DataTable();
        for (let i = 0; i < this.chartData[0].length - 1; i++) {
            dataTable.addColumn({
                id: i,
                type: (typeof this.chartData[0][i].v),
                label: (this.chartData[0][i].c ? this.chartData[0][i].c : "")
            });
        }
        dataTable.addColumn({
            id: this.chartData[0].length,
            type: 'string',
            role: 'tooltip',
            "p": { "html": true }
        });

        dataTable.addRows(this.chartData);

        return dataTable;
    }

    _getDataView() {
        var dataView = new google.visualization.DataView(this.dataTable);
        var self = this;

        var dataTableCols = JSON.parse(this.dataTable.toJSON()).cols;
        //console.log(dataTableCols);

        var mainChartCol = dataTableCols.find(x => x.type == "number");
        var mainChartColIndex = dataTableCols.indexOf(mainChartCol);

        var colsToHide = dataTableCols.reduce((arr, e, i) => (
            (dataTableCols.indexOf(e) > mainChartColIndex && dataTableCols.indexOf(e) < (dataTableCols.length - 1)) && arr.push(i), arr), []
        );

        var colsToSet = dataTableCols.reduce((arr, e, i) => (
            arr.push(i), arr), []
        ).filter(n => !colsToHide.includes(n));
        colsToSet = colsToSet.slice(0, colsToSet.length - 1);

        var tooltipCols = colsToHide;
        tooltipCols.unshift(mainChartColIndex);
        //console.log(tooltipCols);

        var colTooltip = {
            type: "string",
            role: "tooltip",
            properties: {
                html: true
            },
            calc: function (dt, row) {
                var out = [];
                for (i = 0; i < tooltipCols.length; i++) {
                    var value = dt.getValue(row, tooltipCols[i]);
                    var valueText = value ? dt.getFormattedValue(row, tooltipCols[i]) : "N/D";
                    out.push(`
                        <div class="tooltip-value">
                            ${dataTableCols[tooltipCols[i]].label}: 
                            <strong>${valueText}${self.mode == "livelli" ? "%" : ""}</strong>
                        </div>
                    `)
                }
                return out.join(" ");
            }
        };

        colsToSet.push(colTooltip);

        dataView.hideColumns(colsToHide);
        dataView.setColumns(colsToSet);

        return dataView;

    }

    _getChartOptions(colorvalues, colorhex) {
        return options = {
            //sizeAxis: { minValue: 0, maxValue: 100 },
            title: 'Toppings I Like On My Pizza',
            legend: {
                numberFormat: (this.mode == "livelli" ? '#\'%' : ''),
                suffix: "%",
                textStyle: {
                    bold: true
                }
            },
            backgroundColor: {
                fill: "none"
            },
            defaultColor: "#fff",
            datalessRegionColor: '#f9f9f9',
            tooltip: {
                isHtml: true
            },
            width: "100%",
            height: "100%",
            projection: {
                name: "mercator"
            },
            keepAspectRatio: false,
            region: "IT",
            resolution: "provinces",
            displayMode: "regions",
            colorAxis: {
                values: colorvalues,
                colors: colorhex
            }
        };
    }

    _changeColor() {
        var colorhex = ["#FFFFFF", this.color];
        this.geoChart.setOption('colorAxis.colors', colorhex);
        this.geoChart.draw(this.dataView, this.chartOptions);
    }

    _median(values) {
        const mid = Math.floor(values.length / 2),
            nums = [...values].sort((a, b) => a - b);
        return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
    };

    draw() {
        return true;
    }
}

class BarChart extends Chart {

    constructor(container, data, options) {
        super(container, data, options);
        this.purgedChartData = this._purgedChartData();
        this.sortedChartData = this.purgedChartData.sort(this._sortData.bind(this))
        this.myChartData = this._getMyChartData();
        
        
        this.needFilters = options?.needFilters !== false ? true : false;
        const self = this;

        var values = this._getAllValues(this.filteredObj, "value")
        //console.log("AllValues", values)

        this.chartOptions = {
            title: {
                text: this.getTitle(),
                left: 0,
                top: -15,
                padding: [0, 0, 0, 0],
                textStyle: {
                    width: this.getTitleWidth(),
                    fontSize: 14,
                    overflow: "truncate",
                    ellipsis: "..."
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: function (params, ticket, callback) {
                    return `
                        ${params[0].seriesName}<br />
                        ${params[0].name}: <strong>${params[0].data.value}</strong>
                    `
                }
            },
            legend: false,
            grid: {
                left: '1%',
                right: '3%',
                top: 20,
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                min: 0,
                max: (Math.ceil(Math.ceil(Math.max.apply(Math, values)) / 100) * 100),
            },
            yAxis: {
                type: 'category',
                data: this._getLabels()
            },
            visualMap: {
                orient: 'horizontal',
                left: 36,
                bottom: 0,
                min: Math.floor(Math.min.apply(Math, values)),
                max: Math.ceil(Math.max.apply(Math, values)),
                text: [Math.ceil(Math.max.apply(Math, values)), Math.floor(Math.min.apply(Math, values))],
                dimension: 0,
                inRange: {
                    color: (this.domain == "literacy" ? this.chartColorsBlu :
                        (this.domain == "numeracy" ? this.chartColorsGreen : this.chartColorsRed)
                    )
                }
            },
            series: [
                {
                    name: `${this.domain.charAt(0).toUpperCase() + this.domain.slice(1)} ${this.anno}`,
                    type: 'bar',
                    data: this.myChartData
                }
            ]
        };

        if (this.needFilters) this.drawFilters();
    }

    drawFilters() {
        this.drawFilter({ name: "anno", label: "Anno", selectedOpts: [this.anno] }, this.yearFilterValues, null, this.options.needFilters);
        this.drawFilter({ name: "domain", label: "Dominio cognitivo" }, this.domainFilterValues, null, this.options.needFilters);
        this.drawFilter({ name: "unselectedAreas", label: "Territorio", multiple: true, selectedOpts: this.areasMapping.map((el) => el.name) }, this.areasMapping, null, this.options.needFilters);
        this.drawFilter({ name: "indicatore", label: "Caratteristiche" }, this.indicatorFilterValues.prepend({ name: "", label: "Totale" }), null, this.options.needFilters);
    }

    _setFilterEvent(inputName) {
        const self = this;
        super._setFilterEvent(inputName, function () {

            const chart = new BarChart(self.container, self.rawData, {
                needFilters: (inputName == "anno"),
                anno: self.anno,
                domain: (inputName == "anno" ? null : self.domain),
                indicatore: (inputName == "anno" ? null : self.indicatore),
                unselectedAreas: (inputName == "anno" ? null : self.unselectedAreas)
            });
            chart.draw();
        });
    }

    _getMyChartData() {
        const self = this;
        var out = this.sortedChartData
            .map((area, index) => {
                const value = this._getValueObject(area).value;
                return {
                    value: value,
                    itemStyle: {
                        color: (self.domain == "literacy" ? self.chartColorsBlu :
                            (self.domain == "numeracy" ? self.chartColorsGreen : self.chartColorsRed)
                        )[index]
                    }
                }
            })
        //console.log("_getMyChartData", out)
        return out;
    }

    _getLabels() {
        var out = this.sortedChartData
            .map((area) => {
                obj = this.areasMapping.find(x => x.name === area.area);
                return obj ? obj.label : 'Italia'
            })
        //console.log("_getLabels", out)
        return out;
    }


    _purgedChartData() {
        return this.chartData.filter((area) => {
            return this._getValueObject(area).value != "nd"
        })
    }

    _sortData(a, b) {
        return (Object.keys(a).includes("value") ? a.value - b.value : this._getValueObject(a).value - this._getValueObject(b).value);
    }

    
    draw() {
        const chart = echarts.init(this.container, {}, { locale: "IT" });
        chart.setOption(this.chartOptions);
    }

    _getColor(index) {
        return ["#0072bc", "#5088c7", "#799ed3", "#9cb5de", "#becde9", "#dfe6f4"].reverse()[index];
    }

}
class StackedBarChart extends Chart {

    constructor(container, data, options) {
        super(container, data, { ...options, mode: "livelli"});
        this.myChartData = this._getMyChartData();
        this.needFilters = options?.needFilters !== false ? true : false;
        
        //console.log(this.myChartData)

        this.chartOptions = {
            title: {
                text: this.getTitle(),
                left: 15,
                top: -15,
                padding: [0, 0, 0, 0],
                textStyle: {
                    width: this.getTitleWidth(),
                    fontSize: 14,
                    overflow: "truncate",
                    ellipsis: "..."
                }
            },
            grid: {
                top: 35,
                bottom: 30
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: function (params, index) {
                    [params[0], params[1]] = [params[1], params[0]];
                    let out = `<strong>${params[0].name}</strong><br>`;
                    const items = params.map((el, index) => {
                        return `${el.marker} ${el.seriesName}: <strong>${Math.abs(el.value) }%</strong>`
                    }).join("<br>")
                    return out + items;
                }
            },
            legend: {
                orient: 'horizontal',
                center: 'center',
                top: 0,
                icon: "none",
                itemGap: 0,
                itemWidth: -4,
                borderRadius: 0,
                data: this._getLevels().map((el, index) => {
                    const levelObj = this.levelMapping.find(x => x.name === el);
                    return { 
                        name: levelObj.label, 
                        textStyle: { 
                            backgroundColor: (this.domain == "literacy" ? levelObj.colorBlu :
                                (this.domain == "numeracy" ? levelObj.colorGreen : levelObj.colorRed)
                            ),
                            shadowColor: "#ce0000",
                            color: (levelObj.name < 3 ? "#000" : "#fff"),
                            padding: [5, 15, 2, 15],
                            borderRadius: 0,
                            height: 15,
                            fontSize: 12,
                            lineHeight: 12,
                            //width: 50,
                            center: "center"
                        } 
                    }
                })
            },
            xAxis: [
                {
                    type: 'value',
                    min: -100,
                    max: 100,
                    axisLabel: {
                        formatter: function (value, index) {
                            //return (Math.abs(value) + "%");
                            return "";
                        }
                    }
                }
            ],
            yAxis: [
                {
                    type: 'category',
                    axisTick: {
                        show: false
                    },
                    data: this._getLabels()
                }
            ],
            series: this.myChartData.map((el, index) => { 
                //console.log(el);
                return { ...el, ...{
                    data: el.data.reverse(),
                    type: 'bar',
                    stack: 'total',
                    label: {
                        width: 100,
                        fontSize: 10,
                        show: true,
                        position: [14, "44%"],
                        textBorderColor: 'transparent',
                        overflow: "truncate",
                        formatter: function(params){
                            var prefix = "";
                            if (params.value > 0 && Math.abs(params.value) > 2 && Math.abs(params.value) < 10){
                                for (let i = 12; i >= Math.abs(params.value); i--) {
                                    prefix += "\u00A0";
                                }
                            }
                            //console.log(Math.abs(params.value), prefix)
                            if (Math.abs(params.value) > 0) {
                                //return `${prefix}${Math.abs(params.value)}%`;
                                return `${Math.abs(params.value)}%`;
                            }else {
                                return ``;
                            }
                        }
                    },
                    itemStyle: {
                        color: (this.domain == "literacy" ? this.levelMapping.find(x => x.name === el.level).colorBlu : 
                            (this.domain == "numeracy" ? this.levelMapping.find(x => x.name === el.level).colorGreen : this.levelMapping.find(x => x.name === el.level).colorRed)
                        ),
                    },
                    emphasis: {
                        focus: 'series'
                    }
                }
            }}) 
        };

        if (this.needFilters) this.drawFilters();
    }

    getTitle() {
        var out = `${this.anno} ${this.domain.toUpperCase()}`;
        if (!this.indicatore.name && !this.indicatore.value) return out;
        var indicatoreObj = this.indicatorFilterValues.find(o => o.name === this.indicatore.name);
        out += ` | ${indicatoreObj.label}: ${indicatoreObj.options.find(o => o.name === this.indicatore.value).label.toLowerCase()}`;
        return out;
    }

    drawFilters() {
        this.drawFilter({ name: "anno", label: "Anno", selectedOpts: [this.anno] }, this.yearFilterValues, null, this.options.needFilters);
        this.drawFilter({ name: "domain", label: "Dominio cognitivo" }, this.domainFilterValues, null, this.options.needFilters);
        this.drawFilter({ name: "unselectedAreas", label: "Territorio", multiple: true, selectedOpts: this.areasMapping.map((el) => el.name) }, this.areasMapping, null, this.options.needFilters);
        // this.drawFilter({ name: "indicatore", label: "Caratteristiche" }, this.indicatorFilterValues.prepend({ name: "", label: "Totale" }), null, this.options.needFilters);
    }

    _setFilterEvent(inputName) {
        const self = this;
        super._setFilterEvent(inputName, function () {

            const chart = new StackedBarChart(self.container, self.rawData, {
                needFilters: (inputName == "anno"),
                anno: self.anno,
                domain: (inputName == "anno" ? null : self.domain),
                //indicatore: (inputName == "anno" ? null : self.indicatore),
                unselectedAreas: (inputName == "anno" ? null : self.unselectedAreas)     
            });
            chart.draw();
        });
    }

    _getMyChartData() {
        var levels = this._getLevels();
        const out = levels.map(level => {
            return {
                level: level,
                name: this.levelMapping.find(x => x.name === level).label,
                data: this.chartData.map(y => ([1, 2].includes(level) ? -1 : 1) * this._getValueObject(y.values.find(x => x.level == level)).value)
            }
        });
        [out[0], out[1]] = [out[1], out[0]];
        return out;
    }

    _sortData(a, b) {
        return (Object.keys(a).includes("value") ? a.value - b.value : this._getValueObject(a).value - this._getValueObject(b).value);
    }

    _getLabels() {
        return this.chartData.reverse().map(area => { return this.areasMapping.find(x => x.name === area.area).label })
    }

    _getLevels(){
        const out = this.chartData[0].values.map(x => x.level);
        return out;

    }

    draw() {
        const chart = echarts.init(this.container, { }, { locale: "IT" });
        chart.setOption(this.chartOptions);
    }

}
class ScatterChart extends Chart {
    constructor(container, data, options) {
        super(container, data, options);
        
        echarts.registerTransform(ecStat.transform.clustering);
        const myChartData = this._getMyChartData();
        this.needFilters = options?.needFilters !== false ? true : false;
     
        //this.selectedComparison = options?.selectedComparison || [this.domainFilterValues[0], this.domainFilterValues[1]];
        var dataset = [{ source: myChartData }];
        var series = [];

        this.domainCouples = this.domainFilterValues.flatMap(
            (v, i) => this.domainFilterValues.slice(i + 1).map((w) => {
                return { label: (this.capitalizeFirstLetter(v) + ' / ' + this.capitalizeFirstLetter(w)), name: [v, w] }
            })
        )

        console.log(this.selectedComparison)

        var xValues = this._getAllValues(this.filteredObj[0], "value")
        var yValues = this._getAllValues(this.filteredObj[1], "value")
        //console.log(xValues, yValues)
        
        for (let j = 0; j < myChartData.length; j++) {
            dataset.push({
                transform: {
                    type: 'filter',
                    config: {
                        dimension: 4,
                        eq: myChartData[j][4]
                    }
                }
            })

            series.push(
                {
                    "name": myChartData[j][3],
                    "type": 'scatter',
                    "symbolSize": 50,
                    "datasetIndex": (j + 1),
                    "encode": { tooltip: [0, 1] },
                    "itemStyle": {
                        "shadowBlur": 10,
                        "shadowColor": 'rgba(120, 36, 50, 0.5)',
                        "shadowOffsetY": 5,
                        "color": this._getColor(myChartData[j][2])
                    },
                }
            )
        }

        dataset.push({
            transform: {
                type: 'ecStat:clustering',
                config: { clusterCount: myChartData.length, outputClusterIndexDimension: 2 } //, outputType: 'single'
            }
        });


        this.chartOptions = {
            title: {
                text: this.getTitle(),
                left: 15,
                top: -15,
                padding: [0, 0, 0, 0],
                textStyle: {
                    width: this.getTitleWidth(),
                    fontSize: 14,
                    overflow: "truncate",
                    ellipsis: "..."
                }
            },
            dataset: dataset,
            tooltip: {
                position: 'top',
                formatter: (params, index) => {
                    //console.log(params)
                    let out = `<strong>${params.seriesName}</strong><br>`;
                    out += `${params.marker} ${this.selectedComparison[0]}: <strong>${Math.abs(params.data[0])}</strong><br>`
                    out += `${params.marker} ${this.selectedComparison[1]}: <strong>${Math.abs(params.data[1])}</strong>`
                    return out;
                }
            },
            legend: {
                data: this.areasMapping.map(x => x.label),
                top: 0,
            },
            grid: { 
                left: "10%",
                top: 50,
                right: 25
            },
            xAxis: {
                name: this.capitalizeFirstLetter(this.selectedComparison[0]),
                nameLocation: 'middle',
                nameGap: 40,
                min: (Math.floor(Math.floor(Math.min.apply(Math, xValues)) / 10) * 10) - 10,
                max: (Math.ceil(Math.ceil(Math.max.apply(Math, xValues)) / 10) * 10) + 10
            },
            yAxis: {
                name: this.capitalizeFirstLetter(this.selectedComparison[1]),
                nameLocation: 'middle',
                nameGap: 40,
                min: (Math.floor(Math.floor(Math.min.apply(Math, yValues)) / 10) * 10) - 10,
                max: (Math.ceil(Math.ceil(Math.max.apply(Math, yValues)) / 10) * 10) + 10
            },
            series: series
        };

        if (this.needFilters) this.drawFilters();
    }

    getTitle() {
        var out = `${this.anno} Confronto tra i punteggi medi di literacy e numeracy`;
        if (!this.indicatore.name && !this.indicatore.value) return out;
        var indicatoreObj = this.indicatorFilterValues.find(o => o.name === this.indicatore.name);
        out += ` | ${indicatoreObj.label}: ${indicatoreObj.options.find(o => o.name === this.indicatore.value).label.toLowerCase()}`;
        return out;
    }

    drawFilters() {
        this.drawFilter({ name: "anno", label: "Anno", selectedOpts: [this.anno] }, this.yearFilterValues, null, this.options.needFilters);
        if (this.domainFilterValues.length > 2) {
            this.drawFilter({ name: "selectedComparison", label: "Confronta i domini cognitivi" }, this.domainCouples, null, this.options.needFilters);
        }else {
            $("[name='selectedComparison']").closest(".chart-filter-container").remove();
        }
        //this.drawFilter({ name: "unselectedAreas", label: "Macroregioni", multiple: true, selected: true }, this.areasMapping);
        this.drawFilter({ name: "indicatore", label: "Caratteristiche" }, this.indicatorFilterValues.prepend({ name: "", label: "Totale" }), null, this.options.needFilters);
    }

    _setFilterEvent(inputName) {
        const self = this;
        super._setFilterEvent(inputName, function () {

            const chart = new ScatterChart(self.container, self.rawData, {
                needFilters: (inputName == "anno"),
                anno: self.anno,
                domain: (inputName == "anno" ? null : self.domain),
                selectedComparison: (inputName == "anno" ? null : self.selectedComparison),
                indicatore: (inputName == "anno" ? null : self.indicatore),
                unselectedAreas: (inputName == "anno" ? null : self.unselectedAreas)    
            });
            chart.draw();
        });
    }

    _getChartData(data) {

        const chartData = JSON.parse(JSON.stringify(this.rawData[this.mode])); // clono la struttura dati di this.rawData
        const yearObj = chartData.find(el => el.anno === this.anno);

        let filteredObj = null;

        // Filtro per indicatore (genere, età etc...)
        if (!!Object.keys(this.indicatore).length) {
            filteredObj = yearObj.types.filter((el) => this.selectedComparison.includes(el.domain) )
                .map(x => x.values.find(el => el.name === this.indicatore.name).values);
            this.filteredObj = JSON.parse(JSON.stringify(filteredObj));
            if (this.indicatore.value) {
                for (let j = 0; j < filteredObj.length; j++) {
                    for (let i = 0; i < filteredObj[j].length; i++) {
                        filteredObj[j][i].values = filteredObj[j][i].values.find(el => el.name === this.indicatore.value)
                    }
                }
            }
        } else {
            filteredObj = yearObj.types.filter((el) => this.selectedComparison.includes(el.domain)).map(x => x.values[0].values);
            this.filteredObj = JSON.parse(JSON.stringify(filteredObj));
        }

        // Filtro per macroregioni non selezionate
        if (this.unselectedAreas.length) {
            filteredObj = filteredObj.map(x => x.filter(el => this.unselectedAreas.indexOf(el.area) !== -1))
        }
        return filteredObj;
    }

    _getMyChartData() {
        var groupedByAreaObj = this._getGroupedData()

        data = []
        Object.keys(groupedByAreaObj).sort().forEach((key, index) => {
            var itemArray = groupedByAreaObj[key].map(x => {
                return this._getValueObject(x).value
            })
            itemArray.push(key);
            itemArray.push(this.areasMapping.find(el => { return el.name == key }).label);
            itemArray.push(index);
            data.push(itemArray);
        });
        return data;

    }

    _getGroupedData() {
        return this.chartData.flat().reduce((r, a) => { r[a.area] = r[a.area] || []; r[a.area].push(a); return r }, Object.create(null))
    }

    _getLabels() {
        var groupedByAreaObj = this._getGroupedData()
        data = []
        Object.keys(groupedByAreaObj).forEach((key, index) => {
            var area = this.areasMapping.find(x => x.name === key);
            data.push({ value: index, label: area.label, color: this._getColor(key) },);
        });
        return data;
    }

    draw() {
        const chart = echarts.init(this.container, {}, { locale: "IT" });
        chart.setOption(this.chartOptions);
    }
}